import React from 'react';
import loadable from '@loadable/component';
import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { camelize } from '../../util/string';
import { propTypes } from '../../util/types';
import { useLocale } from '../../hooks/useLocale';
import FallbackPage from '../LandingPage/FallbackPage';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

export const CMSPageComponent = props => {
  const { pageAssetsData, inProgress, error, pageId } = props;

  console.log('🔎 CMSPage pageId =', pageId);

  // 🚨 PROTECTION : si pageId manquant, on affiche rien + erreur console
  if (!pageId) {
    console.error('❌ CMSPage: pageId manquant ! Route mal configurée.');
    return <div>Page non trouvée</div>;
  }

  const { locale } = useLocale();

  let localizedPageId = pageId;

  if (pageId === 'about') {
      if (locale === 'nl') localizedPageId = 'about-nl';
      else if (locale === 'en') localizedPageId = 'about-en';
    } else if (pageId === 'privacy-policy') {
      if (locale === 'nl') localizedPageId = 'privacy-policy-nl';
      else if (locale === 'en') localizedPageId = 'privacy-policy-en';
    } else if (pageId === 'terms-of-service') {
      if (locale === 'nl') localizedPageId = 'terms-of-service-nl';
      else if (locale === 'en') localizedPageId = 'terms-of-service-en';
    } else if (pageId === 'partners') {
      if (locale === 'nl') localizedPageId = 'partners-nl';
      else if (locale === 'en') localizedPageId = 'partners-en';
  }

  // DEBUG
  console.log('📄 Page demandée:', pageId);
  console.log('🌍 Locale:', locale);
  console.log('✅ Page chargée:', localizedPageId);

  // camelize seulement si pageId valide
  const camelizedPageId = camelize(localizedPageId);
  let pageData = pageAssetsData?.[camelizedPageId]?.data;

  // 🔄 FALLBACK HYDRATATION:
  // Si la donnée traduite n'est pas encore là (ex: on est sur le client en NL, mais le serveur a rendu en FR)
  // on utilise la donnée de base (FR) passée par le serveur pour hydrater correctement sans dupliquer le DOM.
  if (!pageData) {
    const fallbackPageId = camelize(pageId);
    pageData = pageAssetsData?.[fallbackPageId]?.data;
  }

  if (!pageData) {
    if (inProgress || !error) {
      // Pour éviter le "flash" d'erreur, et pour forcer React à nettoyer le DOM en cas de désync complète (éviter les doublons),
      // on retourne une div invisible plutôt que `null`.
      return <div className="cms-page-loading" style={{ minHeight: '100vh' }} />;
    }
    console.error('❌ Asset manquant pour:', camelizedPageId);
    return <div>Contenu non disponible</div>;
  }

  return (
    <>
      <PageBuilder pageAssetsData={pageData} schemaType="WebPage" />
    </>
  );
};


CMSPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
  error: propTypes.error,
};

const mapStateToProps = (state, ownProps) => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};

  // pageId peut venir de :
  // 1) params.pageId (routes avec :pageId dans l'URL)
  // 2) ownProps.pageId (routeConfiguration)
  const pageId = ownProps.params?.pageId || ownProps.pageId;

  return { pageAssetsData, inProgress, error, pageId };
};



const CMSPage = compose(connect(mapStateToProps))(CMSPageComponent);

export default CMSPage;
